import { takeLatest, call, put, delay, select, takeEvery } from "redux-saga/effects"
import {
	GET_TIMELINE_SEARCH_REQUEST,
	TIMELINE_SEARCH_TYPING,
	TIMELINE_SEARCH_SUCCESS,
	LOGOUT,
	SHOW_ALERT,
	JOB_STATUS_SUCCESS,
	JOB_STATUS_PENDING,
	TIMELINE_SEARCH_CLEAR_CONCEPT_TARGET_TERMS,
	TIMELINE_SEARCH_ADD_CONCEPT_TARGET_TERMS,
	TIMELINE_SEARCH_ERROR,
	TIMELINE_SEARCH_DOCS_DATA_SUCCESS,
	GET_GRAPH_DATA_REQUEST,
	GET_SAVED_DATE_RANGE,
	POST_SAVED_DATE_RANGE,
	DELETE_SAVED_DATE_RANGE,
	GET_SAVED_DATE_RANGE_NAME_CHECK,
} from "../types"
import { documentsService } from "../services/documents.services"
import { clearMultibase } from "../actions/multiAiBase"
import {
	CONTEXT_TYPE,
	CLIENT_SIDE_MESSAGES as Messages,
	buildQueryString,
	clearLocalStorage,
	getTimelinePayload,
	payloadParsing,
	reSortArray,
	searchTermParse,
} from "../utils"
import axios from "../services/axios"
import axiosClient from "axios"
import {
	checkNameAlreadyExistFailed,
	checkNameAlreadyExistSuccess,
	deleteSavedDateRangeFailed,
	deleteSavedDateRangeSuccess,
	getGraphDataRequestClear,
	getGraphDataRequestFailed,
	getGraphDataRequestSuccess,
	getSavedDateRangeFailed,
	getSavedDateRangeSuccess,
	getTimeLineSearchDataClear,
	getTimeLineSearchDataFailed,
	postSavedDateRangeFailed,
	postSavedDateRangeSuccess,
} from "../actions/createTimelineActions"
import { setFilterJobId } from "../actions/filterActions"
import moment from "moment"
import { setNotification } from "../actions/notificationActions"
import { reviewService } from "../services/review.services"
import history from "../utils/history"

const getStatusByJobId = async (id) => {
	return await axios.get(`/job/${id}`)
}

const getPsearchStatusByJobId = async (id) => {
	return await axios.get(`/p_search/${id}`)
}

function* timelineSearchSaga(action) {
	const state = yield select()
	const {
		searchObject,
		filter,
		categories,
		cancelToken,
		pageSize,
		skipCount,
		sort,
		filters,
		page_context,
		skip_audit,
		selecteGraphdDateRange,
		restrict_file_ids,
		review_id,
		is_case_admin,
	} = action.payload
	const searchTearms = searchTermParse(searchObject)
	yield put({
		type: TIMELINE_SEARCH_TYPING,
		payload: true,
	})

	try {
		let sourceApi = state.sources.docs_sources
		let searchId = state?.savedSearch?.selectedSearch?.id
		let showDuplicate = state?.filter?.showDuplicate
		let reviewId = review_id || state?.review?.review?.id
		const subjectText = state?.filter?.subject

		let response = null
		const timelinePayload = getTimelinePayload(
			searchTearms,
			"",
			filter,
			categories,
			false,
			pageSize,
			cancelToken,
			sourceApi,
			skipCount,
			sort,
			filters,
			page_context,
			skip_audit,
			searchId,
			showDuplicate,
			selecteGraphdDateRange,
			restrict_file_ids,
			reviewId,
			is_case_admin,
			subjectText
		)
		const payload = payloadParsing(timelinePayload) //new payload conversion

		if (timelinePayload?.additional_params?.review_id) {
			//review search API
			const { is_case_admin, review_id, ...restPayload } = payload
			response = yield call(reviewService.getReviewSearch, { review_id, is_case_admin }, restPayload)
		} else {
			//search API
			response = yield call(documentsService.createTimelineSearch, payload)
		}

		if (response?.data?.success) {
			const queryString = buildQueryString(timelinePayload)
			const url = `${window.location.pathname}?${queryString}`
			history.push(url)

			const concept = response
			const count = concept?.data?.count || 0

			const docIdArray = []
			for (var i = 0; i < concept?.data?.data?.length; i++) {
				docIdArray.push(`${concept.data.data[i].file_id}`)
			}

			let contextId, context

			if (reviewId) {
				contextId = reviewId
				context = CONTEXT_TYPE?.REVIEW
			} else if (searchId) {
				contextId = searchId
				context = CONTEXT_TYPE?.SEARCH
			}

			const response_docsData = yield call(documentsService.getFilesMetadata, docIdArray, contextId, context)

			yield put({
				type: TIMELINE_SEARCH_DOCS_DATA_SUCCESS,
				payload: response_docsData.data.data,
			})
			yield put({
				type: TIMELINE_SEARCH_SUCCESS,
				payload: {
					conceptData: concept,
					responseDocsData: response_docsData.data.data,
				},
			})
			yield put({
				type: TIMELINE_SEARCH_CLEAR_CONCEPT_TARGET_TERMS,
				payload: searchTearms,
			})
			// if (categories.length > 0) {
			// 	yield call(getTargetTermsOfCategory, categories)
			// }
			yield put({
				type: TIMELINE_SEARCH_ADD_CONCEPT_TARGET_TERMS,
				payload: searchTearms,
			})
		} else {
			yield put(getTimeLineSearchDataFailed(response?.message))
			yield delay(3000) //After 3sec message disappear
			yield put(getTimeLineSearchDataClear())
		}
	} catch (error) {
		console.log(error)
		try {
			if (axiosClient?.isCancel(error)) {
			} else {
				if (error?.response?.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put({
						type: LOGOUT,
						payload: null,
					})
					return
				}
				yield put({
					type: TIMELINE_SEARCH_ERROR,
					payload: true,
				})
				let alert = {
					msg: "There was an error. Please, try again and check your connection",
					class: "alert alert-danger",
				}
				yield put({
					type: SHOW_ALERT,
					payload: alert,
				})
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* getGraphDataSaga(action) {
	try {
		let response = null
		const { page_size, ...OtherPayload } = payloadParsing(action.payload) //new payload conversion
		if (action.payload?.params?.additional_params?.review_id) {
			//review search API
			const { is_case_admin, review_id, ...restPayload } = OtherPayload
			response = yield call(reviewService.getReviewSearch, { review_id, is_case_admin }, restPayload)
		} else {
			//search API
			response = yield call(documentsService.getGraphData, OtherPayload)
		}
		if (response?.data?.success) {
			const concept = response
			const data = concept?.data?.data || []

			if (data.length > 0) {
				const graphData = data.map((ele) => ele?.tagged_date) //format data
				graphData.sort((date_one, date_two) => moment(date_one).diff(moment(date_two))) //sort data

				const dateMap = new Map() //structure build {date: documentCount}
				for (const element of graphData) {
					let iterator = moment.utc(element).format("MM-DD-YYYY") //convert dateto UTC timezome
					if (dateMap.has(iterator)) {
						dateMap.set(iterator, dateMap.get(iterator) + 1)
					} else {
						dateMap.set(iterator, 1)
					}
				}

				const formatedData = [] //1st column in the graph
				dateMap.forEach(function (value, key) {
					//formatedData.push([new Date(key), value])

					const date = new Date(key)

					const utcTimestamp = Date.UTC(
						date.getUTCFullYear(),
						date.getUTCMonth(),
						date.getUTCDate(),
						date.getUTCHours(),
						date.getUTCMinutes(),
						date.getUTCSeconds(),
						date.getUTCMilliseconds()
					)

					// Adjust for local time zone offset
					const localTimestamp = utcTimestamp - date.getTimezoneOffset() * 60 * 1000

					formatedData.push([localTimestamp, value])
				})
				yield put(getGraphDataRequestSuccess(data))
			} else {
				yield put(getGraphDataRequestSuccess([])) //no result
			}
		} else {
			yield put(getGraphDataRequestFailed(response?.message))
			yield delay(3000) //After 3sec message disappear
			yield put(getGraphDataRequestClear())
		}
	} catch (error) {
		console.log(error)
		try {
			if (axiosClient?.isCancel(error)) {
			} else {
				if (error?.response?.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put({
						type: LOGOUT,
						payload: null,
					})
					return
				}
				yield put({
					type: TIMELINE_SEARCH_ERROR,
					payload: true,
				})
				let alert = {
					msg: "There was an error. Please, try again and check your connection",
					class: "alert alert-danger",
				}
				yield put({
					type: SHOW_ALERT,
					payload: alert,
				})
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* getSavedDateRangeSaga() {
	try {
		const result = yield call(documentsService?.getSavedDateRange)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(getSavedDateRangeSuccess(result?.data?.data))
		} else {
			yield put(getSavedDateRangeFailed(result?.data?.message))
		}
	} catch (error) {
		yield put(getSavedDateRangeFailed(Messages.SERVER_ERROR))
	}
}

function* postSavedDateRangeSaga(action) {
	try {
		const result = yield call(documentsService?.postSavedDateRange, action?.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(postSavedDateRangeSuccess(result?.data?.data))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
					duration: 5000,
				})
			)
			yield call(getSavedDateRangeSaga)
		} else {
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "error",
					duration: 5000,
				})
			)
			yield put(postSavedDateRangeFailed(result?.data?.message))
		}
	} catch (error) {
		yield put(postSavedDateRangeFailed(Messages.SERVER_ERROR))
	}
}

function* deleteSavedDateRangeSaga(action) {
	try {
		const result = yield call(documentsService?.deleteSavedDateRange, action?.payload)
		console.log("deleteSavedDate", result)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(deleteSavedDateRangeSuccess(result?.data?.data))
			yield call(getSavedDateRangeSaga)
		} else {
			yield put(deleteSavedDateRangeFailed(result?.data?.message))
		}
	} catch (error) {
		yield put(deleteSavedDateRangeFailed(Messages.SERVER_ERROR))
	}
}

function* checkNameAlreadyExistSaga(action) {
	try {
		const result = yield call(documentsService?.checkNameAlreadyExist, action?.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(checkNameAlreadyExistSuccess(result?.data?.data))
			yield call(getSavedDateRangeSaga)
		} else {
			yield put(checkNameAlreadyExistFailed(result?.data?.message))
		}
	} catch (error) {
		yield put(checkNameAlreadyExistFailed(Messages.SERVER_ERROR))
	}
}

export default function* timelineSagas() {
	yield takeLatest(GET_TIMELINE_SEARCH_REQUEST, timelineSearchSaga)
	yield takeLatest(GET_GRAPH_DATA_REQUEST, getGraphDataSaga)
	yield takeLatest(GET_SAVED_DATE_RANGE, getSavedDateRangeSaga)
	yield takeLatest(POST_SAVED_DATE_RANGE, postSavedDateRangeSaga)
	yield takeLatest(DELETE_SAVED_DATE_RANGE, deleteSavedDateRangeSaga)
	yield takeLatest(GET_SAVED_DATE_RANGE_NAME_CHECK, checkNameAlreadyExistSaga)
}
